import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
// import { MusicPlayer } from '../MusicPlayer';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import { Toaster } from 'react-hot-toast';

export const Layout = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />

      <div className="flex">
        <Sidebar />

        <main className="flex-1 p-6 pt-20 md:ml-64">
          <Suspense fallback={<LoadingSpinner />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      {/* <MusicPlayer /> */}
      <Toaster position="top-right" />
    </div>
  );
};
